<div class="gw-w-full gw-max-w-2xl gw-mx-auto gw-px-6 gw-py-6">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="gw-space-y-6">
    <div class="gw-space-y-4">
      <p class="gw-text-text-primary gw-text-base">
        {{
          'features.settings.parameters.' + setting.key + '.description'
            | translate
        }}
      </p>
      <div class="gw-space-y-3">
        <ng-container *ngFor="let provider of availableProviders">
          <label class="gw-flex gw-items-center gw-gap-[8px] gw-cursor-pointer">
            <input
              type="checkbox"
              [formControlName]="provider"
              class="gw-w-[20px] gw-h-[20px] gw-rounded-[6px] gw-cursor-pointer"
            />
            <span class="gw-text-[16px] gw-text-text-secondary">
              {{ getProviderLabel(provider) }}
            </span>
          </label>
        </ng-container>
      </div>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
